// it is in separate import because you can't insert code between imports
import cuckoo from "common/services/cuckoo/cuckoo"
import { cuckooEvents } from "common/consts/enums"
import * as perfTracker from "common/utils/perfTracker"

perfTracker.onBeforeImport()

cuckoo.track(cuckooEvents.GENERAL_PAGE_PARSING, {
  timeFromBegin: perfTracker.getBeginToBeforeImportDuration(),
})
